import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../../../redux/store';
import { listenToShortstayData, upsertShortstay } from '../../../../redux/shortstaysSlice';

const OPTIONS = [
  {
    id: 'entire_place',
    title: 'An entire place',
    description: 'Guests have the whole place to themselves.',
  },
  {
    id: 'room',
    title: 'A room',
    description: 'Guests have their own room in a home, plus access to shared spaces.',
  },
  {
    id: 'shared_room',
    title: 'A shared room in a hostel',
    description: 'Guests sleep in a shared room in a professionally managed hostel with staff onsite 24/7.',
  },
];

const ShortTypes: React.FC = () => {
  const { listingId } = useParams<{ listingId: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const currentListing = useSelector((state: RootState) => state.shortstays.currentListing);

  const [placeType, setPlaceType] = useState<string>('');
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (listingId) {
      dispatch(listenToShortstayData(listingId));
    }
  }, [dispatch, listingId]);

  useEffect(() => {
    if (currentListing?.placeType) {
      setPlaceType(currentListing.placeType);
    }
  }, [currentListing]);

  const handleSelect = (id: string) => {
    setPlaceType(id);
    setHasChanges(true);
  };

  const handleSave = async () => {
    if (!listingId || !hasChanges || !placeType) return;
    await dispatch(upsertShortstay({ listingId, data: { placeType } }));
    alert('✅ Saved successfully!');
    setHasChanges(false);
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <h2 style={styles.heading}>Edit Place Type</h2>
        <button
          style={{
            ...styles.saveButton,
            opacity: hasChanges ? 1 : 0.4,
            pointerEvents: hasChanges ? 'auto' : 'none',
          }}
          onClick={handleSave}
        >
          Save
        </button>
      </div>

      <div style={styles.optionGrid}>
        {OPTIONS.map((opt) => (
          <div
            key={opt.id}
            onClick={() => handleSelect(opt.id)}
            style={{
              ...styles.card,
              background: placeType === opt.id
                ? 'linear-gradient(to right, #111, #bf9b30)'
                : '#fff',
              color: placeType === opt.id ? '#fff' : '#000',
              border: placeType === opt.id ? '2px solid #bf9b30' : '1px solid #ccc',
            }}
          >
            <h3 style={styles.cardTitle}>{opt.title}</h3>
            <p style={styles.cardDesc}>{opt.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShortTypes;

const styles: { [key: string]: React.CSSProperties } = {

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 30,
  },
  heading: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  saveButton: {
    background: 'linear-gradient(to right, #fff, #bf9b30)',
    padding: '10px 24px',
    borderRadius: 30,
    border: 'none',
    fontWeight: 'bold',
    color: '#000',
    cursor: 'pointer',
  },
  optionGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: 20,
  },
  card: {
    borderRadius: 16,
    padding: 20,
    cursor: 'pointer',
    boxShadow: '0 0 10px rgba(255,255,255,0.1)',
    transition: 'all 0.3s ease',
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  cardDesc: {
    fontSize: 14,
    color: '#000000',
  },
};
